import axios from "axios";
import Vue from "vue";

import {
  SUBMIT,
  POPULATE_ONE,
  FETCH,
  DELETE_ONE,
  TOGGLE_DRAWER
} from "@/store/action-types";
import {
  TOGGLE_LOADING,
  // SET_AXIOS_CALL,
  SET_META,
  SET_LIST,
  UPDATE_LIST_ITEM,
  REMOVE_LIST_ITEM,
  CONCAT_LIST,
  SUCCESS,
  ERROR
} from "@/store/mutation-types";

let call;

export const dataTableActionsFactory = ({
  repository,
  model,
  drawerName = null
}) => {
  return {
    async [FETCH](
      { commit, state },
      {
        reset = false,
        temporary = false,
        forceConcat = false,
        search = {}
      } = {}
    ) {
      if (call) {
        call.cancel("Only one request allowed at a time.");
      }

      // commit(SET_AXIOS_CALL, repository.CancelToken.source());
      call = axios.CancelToken.source();

      let searchQuery = search.query || state.searchForm.query;
      let active = search.active || state.searchForm.active;
      let locked = search.locked || state.searchForm.locked;
      let equipe = search.equipe || state.searchForm.equipe;
      let statut = search.statut || state.searchForm.statut;
      let sortField = search.sortField || state.searchForm.options.sortBy[0];
      let sortType =
        search.sortField || state.searchForm.options.sortDesc[0]
          ? "desc"
          : "asc";

      commit(TOGGLE_LOADING, true);

      try {
        const res = await repository.get({
          page: reset || temporary ? 1 : state.pagingMetadata.currentPage + 1,
          searchQuery,
          active,
          locked,
          sortField,
          sortType,
          cancelToken: call.token,
          equipe,
          statut
        });

        const { data, config } = res;

        const list = data.content.list.map(entity => new model(entity));

        if (!temporary) {
          commit(SET_META, {
            pagingMetadata: data.content.pagingMetadata,
            params: config.params
          });
        }

        if (!temporary || forceConcat) {
          commit(reset ? SET_LIST : CONCAT_LIST, {
            list
          });
        }

        commit(TOGGLE_LOADING, false);

        return list;
      } catch (error) {
        if (!axios.isCancel(error)) {
          commit(
            `app/${ERROR}`,
            { error, message: error.message },
            { root: true }
          );
          commit(TOGGLE_LOADING, false);
        } else {
          commit(TOGGLE_LOADING, true);
        }
      }
    },
    async [POPULATE_ONE]({ commit }, id) {
      try {
        commit(TOGGLE_LOADING, true);

        const { data } = await repository.findOneById(id);

        let entity = new model(data.content.entity);

        commit(UPDATE_LIST_ITEM, entity);

        commit(TOGGLE_LOADING, false);

        return entity;
      } catch (error) {
        commit(
          `app/${ERROR}`,
          { error, message: error.message },
          { root: true }
        );
      }

      commit(TOGGLE_LOADING, false);
    },
    async [DELETE_ONE]({ commit, rootGetters }, entity) {
      try {
        commit(TOGGLE_LOADING, true);

        // admin -> DELETE  delegue -> PUT
        if (!rootGetters["auth/hasAdminRights"]) {
          await repository.put({
            entity,
            id: entity.id
          });
        } else {
          await repository.deleteOneById(entity.id);
        }

        commit(REMOVE_LIST_ITEM, new model(entity));

        commit(
          `app/${SUCCESS}`,
          { message: `${entity.entityMessage()} a bien été supprimé` },
          { root: true }
        );
      } catch (error) {
        commit(`app/${ERROR}`, {}, { root: true });
      }

      commit(TOGGLE_LOADING, false);
    },
    async [SUBMIT]({ commit, dispatch, state }) {
      /*
      if (!rootGetters["auth/hasAdminRights"]) {
        commit(
          `app/${ERROR}`,
          {
            message:
              "Vous ne disposez pas des droits suffisants pour modifier des données de l'application."
          },
          { root: true }
        );

        return;
      }
      */

      try {
        commit(TOGGLE_LOADING, true);

        let entity = new model(state.createForm.entity);

        const { data } = await repository.put({
          entity,
          id: state.createForm.entity.id
        });

        if ("id" in data.content) {
          entity.id = data.content.id;
        }

        if ("entity" in data.content) {
          entity = new model(data.content.entity);
        }

        commit(UPDATE_LIST_ITEM, new model(entity));

        dispatch(
          `app/${TOGGLE_DRAWER}`,
          { drawerName, toggle: false },
          { root: true }
        );

        commit(
          `app/${SUCCESS}`,
          { message: `${entity.entityMessage()} a bien été mis à jour` },
          { root: true }
        );
      } catch (error) {
        commit(
          `app/${ERROR}`,
          { error, message: error.message },
          { root: true }
        );
      }

      commit(TOGGLE_LOADING, false);
    }
  };
};

export const dataTableMutations = {
  [TOGGLE_LOADING](state, toggle) {
    if (toggle == null) {
      toggle = !state.loading;
    }
    // eslint-disable-next-line no-param-reassign
    state.loading = toggle;
  },
  [SET_META](state, { pagingMetadata = {}, params = {} }) {
    state.pagingMetadata = {
      totalCount: pagingMetadata.totalCount,
      pageSize: pagingMetadata.pageSize,
      currentPage: pagingMetadata.currentPage,
      totalPages: pagingMetadata.totalPages,
      previousPage: pagingMetadata.previousPage,
      nextPage: pagingMetadata.nextPage
    };
    state.params = {
      searchQuery: params.criteria,
      actif: params.actif,
      locked: params.locked,
      equipe: params.equipe,
      statut: params.statut,
      applicationId: params.applicationId
    };
  },
  [CONCAT_LIST](state, { list = [] }) {
    // eslint-disable-next-line no-param-reassign
    state.list = state.list.concat(list);
  },
  [SET_LIST](state, { list = [] }) {
    // eslint-disable-next-line no-param-reassign
    state.list = list;
  },
  [UPDATE_LIST_ITEM](state, newItem) {
    let index = state.list.findIndex(el => el.id == newItem.id);

    //console.log(index, newItem);

    if (index != -1) {
      Vue.set(state.list, index, newItem);
    } else {
      state.list.unshift(newItem);
    }
  },
  [REMOVE_LIST_ITEM](state, itemToRemove) {
    let index = state.list.findIndex(el => el.id == itemToRemove.id);

    if (index) {
      state.list.splice(index, 1);
    }
  }
};

export const dataTableState = {
  loading: false,
  call: null,
  list: [],
  pagingMetadata: {},
  params: {
    searchQuery: ""
  },
  error: false,
  success: false,
  previousSearchState: {}
};
